module.exports = __webpack_public_path__ + "media/pricing/fa-close-2684a7ba.png";